import { format } from "date-fns-tz"
import { add } from "date-fns"

// import { parseISO } from "date-fns";

const arrOperationTransaction = [{ text: "Начисление", color: "lime lighten-4" },
  { text: "Использование", color: "light-blue lighten-4" },
  { text: "Аннулирование", color: "orange lighten-4" },
  { text: "Корректировка", color: "blue-grey lighten-4" }]
const arrStatusTransaction = [{ text: "Исполнена", color: "teal lighten-4" },
  { text: "Отклонена", color: "pink lighten-4" }, { text: "В плане", color: "indigo lighten-4" }]

export class TransactionModel {
  constructor (data) {
    this.debitAccount = data.debitAccount
    this.campaignId = data.campaignId
    this.amount = data.amount
    this.bonus = data.bonus
    this.bonusCancellation = data.bonusCancellation ? this._updateDate2(data.bonusCancellation) : ''
    this.operation = arrOperationTransaction[data.operation]
    this.productCode = data.productCode
    this.createDate = this._updateDate(data.createDate)
    this.ruleId = data.ruleId
    this.creditAccount = data.creditAccount
    this.algorithm = data.algorithm
    this.approvalDate = this._updateDate2(data.approvalDate)
    this.status = arrStatusTransaction[data.status]
    this.transactionId = data.transactionId
    this.updateDate = this._updateDate(data.updateDate)
    this.recordId = data.recordId
    this.servicePointId = data.servicePointId
    this.participantId = data.participantId
  }

  toCsv (delimiter) {
    const delim = delimiter || ';'
    return this.debitAccount + delim +
        this.creditAccount + delim +
    this.campaignId + delim +
    this.amount + delim +
    this.bonus + delim +
    this.bonusCancellation + delim +
    this.operation.text + delim +
    this.productCode + delim +
    this.createDate + delim +
    this.ruleId + delim +
    this.algorithm + delim +
    this.approvalDate + delim +
    this.status.text + delim +
    this.transactionId + delim +
    this.updateDate + delim +
    this.recordId + delim + '\n'
  }

  _updateDate (updateDate) {
    const date = new Date(updateDate)
    // const minutes = Math.abs(date.getTimezoneOffset())
    // const local_date = add(date, { minutes: minutes })
    return format(date, "dd.MM.yyyy HH:mm:ss")
  }

  _updateDate2 (updateDate) {
    const date = new Date(updateDate)
    return format(date, "dd.MM.yyyy")
  }
}

export const TransactionTitlesModel = [
  {
    text: "Счёт по дебиту",
    value: "debitAccount",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Счёт по кредиту",
    value: "creditAccount",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Программа лояльности",
    value: "campaignId",
    filterType: "list",
    filterValues: []
  },
  {
    text: "Пользователь",
    value: "participantId",
    filterType: "list",
    filterValues: []
  },
  {
    text: "Наименование продукта (Код продукта)",
    value: "productCode",
    filterType: "list",
    filterValues: []
  },
  {
    text: "Точка обслуживания",
    value: "servicePointId",
    filterType: "list",
    filterValues: []
  },
  {
    text: "Сумма",
    value: "amount",
    filterType: "money",
    filterValues: []
  },
  {
    text: "Бонусы",
    value: "bonus",
    filterType: "money",
    filterValues: []
  },
  {
    text: "Дата обуления бонуса",
    value: "bonusCancellation",
    filterType: "date",
    filterValues: []
  },
  {
    text: "Операция",
    value: "operation",
    filterType: "list",
    filterValues: arrOperationTransaction.map((m, index) => { return Object.fromEntries([['text', m.text], ['value', index]]) })
  },
  {
    text: "Статус",
    value: "status",
    filterType: "list",
    filterValues: arrStatusTransaction.map((m, index) => { return Object.fromEntries([['text', m.text], ['value', index]]) })
  },
  {
    text: "Последняя дата изменения",
    value: "updateDate",
    filterType: "date",
    filterValues: []
  }
]

export const TransactionHeadersModel = TransactionTitlesModel.map(m =>
  Object.fromEntries(
  Object.entries(m)
  .filter(([key]) => ['text', 'value'].includes(key))
)
)
